// Add certifications by copying this template:
// {
//   id: 1,
//   title: "Certification Name",
//   issuer: "Issuing Organization",
//   date: "Month Year",
//   credentialUrl: "https://...", // optional
//   credentialId: "ABC123", // optional
// }

const certifications = [
  {
    id: 1,
    title: "Cloud Computing Foundations",
    issuer: "IBM (edX)",
    date: null,
    credentialUrl: null,
    credentialId: null,
  },
  {
    id: 2,
    title: "Containers, Kubernetes, and OpenShift",
    issuer: "IBM (edX)",
    date: null,
    credentialUrl: null,
    credentialId: null,
  },
  {
    id: 3,
    title: "Microservices, Serverless Architecture, and OpenShift",
    issuer: "IBM (edX)",
    date: null,
    credentialUrl: null,
    credentialId: null,
  },
  {
    id: 4,
    title: "DevOps Fundamentals and Agile Practices",
    issuer: "IBM (edX)",
    date: null,
    credentialUrl: null,
    credentialId: null,
  },
  {
    id: 5,
    title: "Python for Data Science and AI Development",
    issuer: "IBM (edX)",
    date: null,
    credentialUrl: null,
    credentialId: null,
  },
  {
    id: 6,
    title: "Machine Learning with Apache Spark",
    issuer: "IBM (edX)",
    date: null,
    credentialUrl: null,
    credentialId: null,
  },
  {
    id: 7,
    title: "Red Hat Enterprise Linux Fundamentals",
    issuer: "Red Hat (Coursera)",
    date: null,
    credentialUrl: null,
    credentialId: null,
  },
];

export default certifications;
